import { useTranslation } from "react-i18next";
import {
  TableToolbar,
  FilterField,
  FilterInput,
  FilterCheckGroup,
  SortButton,
} from "../../shared/TableToolbar";

export default function TableHeader({
  params = {},
  onParamsChange,
  cuentas = [],
  loading = false,
}) {
  const { t } = useTranslation();

  const METODOS = [
    { value: "TRANSFERENCIA", label: t("recibos.transferencia") },
    { value: "EFECTIVO",      label: t("recibos.efectivo") },
    { value: "CHEQUE",        label: t("recibos.cheque") },
  ];

  function set(field, value) {
    onParamsChange?.({ ...params, [field]: value });
  }

  function clearFilters() {
    onParamsChange?.({
      search: "",
      fecha_desde: "",
      fecha_hasta: "",
      monto_min: "",
      monto_max: "",
      metodo_pago: [],
      cuenta_bancaria: [],
      ordering: "",
    });
  }

  // Toggle entre sin orden → N° ↓ (desc) → N° ↑ (asc) → sin orden
  function toggleOrdering() {
    const current = params.ordering ?? "";
    if (!current) set("ordering", "-numero_recibo");
    else if (current === "-numero_recibo") set("ordering", "numero_recibo");
    else set("ordering", "");
  }

  const orderState =
    params.ordering === "-numero_recibo"
      ? "desc"
      : params.ordering === "numero_recibo"
        ? "asc"
        : "none";

  const orderLabel =
    orderState === "desc"
      ? t("recibos.nReciboDesc")
      : orderState === "asc"
        ? t("recibos.nReciboAsc")
        : t("common.ordenar");

  const activeCount =
    [
      params.fecha_desde,
      params.fecha_hasta,
      params.monto_min,
      params.monto_max,
    ].filter(Boolean).length +
    (params.metodo_pago?.length ?? 0) +
    (params.cuenta_bancaria?.length ?? 0);

  return (
    <TableToolbar
      search={params.search ?? ""}
      onSearch={(v) => set("search", v)}
      searchPlaceholder={t("recibos.buscarPlaceholder")}
      loading={loading}
      sort={<SortButton state={orderState} label={orderLabel} onToggle={toggleOrdering} />}
      activeFilterCount={activeCount}
      onClearFilters={clearFilters}
      filters={
        <>
          <FilterField label={t("common.fechaDesde")}>
            <FilterInput
              type="date"
              value={params.fecha_desde ?? ""}
              onChange={(e) => set("fecha_desde", e.target.value)}
            />
          </FilterField>

          <FilterField label={t("common.fechaHasta")}>
            <FilterInput
              type="date"
              value={params.fecha_hasta ?? ""}
              onChange={(e) => set("fecha_hasta", e.target.value)}
            />
          </FilterField>

          <FilterField label={t("common.montoMinimo")}>
            <FilterInput
              type="number"
              min="0"
              step="1000"
              placeholder="0"
              value={params.monto_min ?? ""}
              onChange={(e) => set("monto_min", e.target.value)}
            />
          </FilterField>

          <FilterField label={t("common.montoMaximo")}>
            <FilterInput
              type="number"
              min="0"
              step="1000"
              placeholder={t("common.sinLimite")}
              value={params.monto_max ?? ""}
              onChange={(e) => set("monto_max", e.target.value)}
            />
          </FilterField>

          <FilterField label={t("common.metodoPago")}>
            <FilterCheckGroup
              options={METODOS}
              selected={params.metodo_pago ?? []}
              onChange={(next) => set("metodo_pago", next)}
            />
          </FilterField>

          {cuentas.length > 0 && (
            <FilterField label={t("common.cuentaBancaria")}>
              <FilterCheckGroup
                options={cuentas.map((c) => ({ value: c.id, label: c.label }))}
                selected={params.cuenta_bancaria ?? []}
                onChange={(next) => set("cuenta_bancaria", next)}
              />
            </FilterField>
          )}
        </>
      }
    />
  );
}
